import { render } from "./EditDepartaments.vue?vue&type=template&id=799a8ad0"
import script from "./EditDepartaments.vue?vue&type=script&lang=js"
export * from "./EditDepartaments.vue?vue&type=script&lang=js"

import "./EditDepartaments.vue?vue&type=style&index=0&id=799a8ad0&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__